import { Dispatch } from "redux";
import { SubscriptionEntitlements } from "src/app/subscription/subscriptionUtils";
import { getSubscriptionEntitlement } from "src/redux";

export const getAllSubscriptionEntitlements = async (
  dispatch: Dispatch,
  workspaceUuid: string,
) => {
  const SUPPORTED_FEATURES = [
    SubscriptionEntitlements.PublicationSentiments,
    SubscriptionEntitlements.Forms,
    SubscriptionEntitlements.CouponsIntegration,
    SubscriptionEntitlements.ClientMode,
    SubscriptionEntitlements.WsXtrmExtension,
    SubscriptionEntitlements.ContactDataVisibility,
    SubscriptionEntitlements.WsMessengerExtension,
    SubscriptionEntitlements.DictionaryManager,
    SubscriptionEntitlements.WhiteLabel,
    SubscriptionEntitlements.APIAccess,
    SubscriptionEntitlements.StorePublishedContentsExtension,
    SubscriptionEntitlements.HashtagLiveSearch,
  ];

  SUPPORTED_FEATURES.forEach((feature) => {
    dispatch(getSubscriptionEntitlement(workspaceUuid, feature));
  });
};
